import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3;
import mediaQueries from "../../../../../util/mediaqueries";
import styled from 'styled-components';
import { SocialIconsList } from "../../social-icons";
import { Link } from "../../cookie-policy-settings-link";
import { Column } from "./column";
export var CompanyInfoColumn = styled(Column).withConfig({
  componentId: "sc-5bcs08-0"
})(["margin-top:-32px;", "{margin-bottom:32px;}", "{margin-bottom:16px;}", ";", ";", ";"], SocialIconsList, Link, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: 0;\n  "]))))), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column: 1 / span 3;\n\n    ", " {\n      margin-bottom: 0;\n    }\n  "])), 0)), SocialIconsList), mediaQueries.lg(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: 10 / -1;\n  "]))))));